module.exports = __webpack_public_path__ + "static/media/wuliu.baf1c508.png";